import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreCommonModule } from 'src/@core/common.module';
import { CoreTouchspinModule } from 'src/@core/components/core-touchspin/core-touchspin.module';
import { ComponentsModule } from 'src/app/components/components.module';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { NavbarBookmarkComponent } from './navbar-bookmark/navbar-bookmark.component';
import { NavbarNotificationComponent } from './navbar-notification/navbar-notification.component';
import { NavbarSearchComponent } from './navbar-search/navbar-search.component';
import { NavbarComponent } from './navbar.component';
import { ApprovalNotificationComponent } from './approval-notification/approval-notification.component';
// import {
//   PerfectScrollbarConfigInterface,
//   PerfectScrollbarModule,
//   PERFECT_SCROLLBAR_CONFIG,
// } from "ngx-perfect-scrollbar";

// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true,
//   wheelPropagation: false,
// };

@NgModule({
  declarations: [
    NavbarComponent,
    NavbarSearchComponent,
    NavbarBookmarkComponent,
    NavbarNotificationComponent,
    ApprovalNotificationComponent,
  ],
  imports: [
    RouterModule,
    NgbModule,
    CoreCommonModule,
    // PerfectScrollbarModule,
    CoreTouchspinModule,
    ComponentsModule,
    DirectivesModule,
    MatIconModule,
    TranslateModule,
  ],
  providers: [
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    // },
  ],
  exports: [NavbarComponent],
})
export class NavbarModule { }
